<template>
  <v-card
    ref="form"
    class="mx-auto mt-5"
    max-width="1000"
    v-if="0 !== null">
    <v-toolbar>
      <v-toolbar-title
        v-if="step <= infoStep">Health Survey</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-progress-circular
        :color="progressColor"
        :value="progress"
        class="mr-2">
        <v-icon
          v-if="step === finalStep"
          color="green">check</v-icon>
      </v-progress-circular>
    </v-toolbar>
    <v-snackbar
      v-model="snackbar"
      :top="true"
      :multi-line="true"
      :timeout="4000"
      color="error">
      {{ errorText }}
      <v-btn
        color="white"
        text
        @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card-title class="title font-weight-regular justify-space-between">
      <span style="word-break: break-word;">{{ currentTitle }}</span>
    </v-card-title>
    <v-window v-model="step">

      <v-window-item :value="nameStep">
        <v-card-text>
          <v-text-field
            v-model="dataModel[0].fname"
            label="First Name"></v-text-field>
          <v-text-field
            v-model="dataModel[0].lname"
            label="Last Name"></v-text-field>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="introStep">
        <div class="pa-3 text-center">
          <v-img
            class="mb-3"
            contain
            height="80"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/icons8-treatment-64.png?alt=media&token=7f1dff34-c5ed-4136-8250-ed3dbbf6da37"></v-img>
          <h3 class="title font-weight-light mb-2">Welcome!</h3>
          <span>Welcome!  Let’s begin by reviewing your health history. ‘Please include any personal history of medical or health issues, including chronic health conditions (such as diabetes, cancer, heart disease or heart attack, high blood pressure or high cholesterol) as well as any other medical concerns or past hospitalizations. Please also indicate when you were diagnosed with the health concern, and if you are currently being treated for it.</span>
        </div>
      </v-window-item>

      <v-window-item :value="genderStep">
        <v-card-text>
          <GenderQuest
            :modifyData="dataModel"
            :modifyIndex="0"/>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="livingStep">
        <v-card-text>
          <v-radio-group
            v-model="dataModel[0].isLiving"
            true-value="true"
            false-value="false">
            <v-radio
              label="Yes"
              :value="true"></v-radio>
            <v-radio
              label="No"
              :value="false"></v-radio>
          </v-radio-group>
        </v-card-text>
      </v-window-item>

      <v-window-item
        :value="ageStep">
        <v-card-text>
          <AgeQuest
            :data="dataModel"
            :modifyIndex="0"/>
        </v-card-text>
      </v-window-item>

      <v-window-item
        :value="ancestryStep">
        <v-card-text>
          <AncestryQuest/>
        </v-card-text>
      </v-window-item>

      <v-window-item
        :value="femaleStep">
        <v-card-text>
          <FemaleQuestions/>
        </v-card-text>
      </v-window-item>

      <v-window-item
        :value="ConditionStep">
        <v-card-text>
          <CondTest
            :modifyData="dataModel"
            :modifyIndex="0"/>
        </v-card-text>
      </v-window-item>

      <v-window-item
        :value="surgeriesStep">
        <v-card-text>
          <Surgeries
            :modifyData="dataModel"
            :modifyIndex="0"/>
        </v-card-text>
      </v-window-item>

      <v-window-item
        :value="medicationStep">
        <v-card-text>
          <Medication/>

          <MedicationAlergy/>
        </v-card-text>
      </v-window-item>

      <v-window-item
        :value="exposuresStep">
        <v-card-text>
          <Exposures/>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="infoStep">
        <v-card-text>
          <v-textarea
            v-model="dataModel[0].notes"
            outline
            name="input-7-4"
            label="Additional pertinent information."
            value></v-textarea>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="finalStep">
        <div class="pa-3 text-center">
          <v-img
            class="mb-3"
            contain
            height="64"
            src="https://firebasestorage.googleapis.com/v0/b/gsf-rgs.appspot.com/o/task-completed.png?alt=media&token=b09bf984-16b2-44a0-beeb-cb3532e5edab"></v-img>

          <span class="caption grey--text">
            Thank you for enrolling in My Genetic Trust. One of our board-certified genetic counselors will review your medical and family history, and you will get an email within one week that will include a list of any additional health records that will be important to include in your My Genetic Trust, as well as any follow-up questions or clarifications. We will include Release of Information forms with this email for you to fill out, sign, and send back to us. We will send those completed forms to the medical offices that performed any testing you have had to request that a copy of those records be sent to our office so we can include it in your My Genetic Trust. After all record requests are completed, the genetic counselor will do a final assessment of your medical and family health history, and will issue your My Genetic Trust report.
          </span>
          <!-- <Pdf
            class="vuepdf"
            style="margin-top : 3%"/> -->
        </div>
      </v-window-item>
    </v-window>

    <v-divider></v-divider>

    <v-card-actions>
      <v-btn
        :disabled="step === 1 || step === finalStep+5 || !formValid"
        text
        @click="stepBack">Back</v-btn>
      <v-spacer></v-spacer>

      <v-btn
        v-if="step < finalStep-1 && complete === true"
        color="info"
        depressed
        @click="step = finalStep-1">Jump to Review</v-btn>

      <v-spacer></v-spacer>
      <v-btn
        v-if="step !== finalStep"
        color="primary"
        depressed
        :disabled="!formValid"
        @click="stepValidate">{{buttonText}}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import FemaleQuestions from "../../components/questionnaire/PatientFormComp/FemaleQuestions.vue";
import AgeQuest from "../../components/questionnaire/PatientFormComp/AgeQuest.vue"
import GenderQuest from "../../components/questionnaire/PatientFormComp/GenderQuest.vue"
import CondTest from "../../components/questionnaire/PatientFormComp/CondTest.vue";
import Surgeries from "./PatientFormComp/Surgeries"
import Exposures from "./PatientFormComp/Exposures"
import Medication from "./PatientFormComp/Medication"
import MedicationAlergy from "./PatientFormComp/MedicationAlergy"
import AncestryQuest from "./PatientFormComp/AncestryQuest"
import { editFamilyHistory, editHealthHistory } from '../../helper/firestore'

export default {
  props: {
    formType: String
  },
  components: {
    AgeQuest,
    CondTest,
    GenderQuest,
    FemaleQuestions,
    Surgeries,
    Medication,
    MedicationAlergy,
    AncestryQuest,
    Exposures,
  },
  data: () => ({
    ageRules: [
      v => (v && v >= 0) || 'Age must be larger or equal to 0'
    ],
    formTypeName: ["the patient’s", "patient", "Has the patient", "Is the patient", "does the patient have"],
    geneTestStep: 0,
    livingStep: 0,
    nameStep: 1,
    introStep: 2,
    genderStep: 3,
    ageStep: 4,
    ancestryStep: 5,
    femaleStep: 6,
    ConditionStep: 7,
    surgeriesStep: 8,
    medicationStep: 9,
    exposuresStep: 10,
    infoStep: 11,
    finalStep: 12,
    complete: false,
    active: true,
    step: 1
  }),
  watch: {
    menu (value) {
      value && this.$nextTick(() => this.$refs.pickerInMenu.activePicker = 'YEAR')
    }
  },
  methods: {
    saveDatatoDB () {
      this.user.familyHistory = this.dataModel
      editFamilyHistory(this.dataModel, () => {
      })
      editHealthHistory(this.user.health, () => {
      })
    },
    stepBack() {
      if (
        this.step === this.ConditionStep &&
        (
          this.dataModel[0].newGender.legal !== 'Female' ||
          this.dataModel[0].newGender.identity !== 'Female' ||
          this.dataModel[0].newGender.assigned !== 'Female'
        )
      ) {
        this.step -= 2
      } else {
        this.step--
      }
    },
    stepValidate() {
      switch (this.step) {
        case this.nameStep:
          if (this.dataModel[0].fname === "") {
            this.snackbar = true;
            this.errorText = "Please enter first name";
            break;
          } else if (this.dataModel[0].lname === "") {
            this.snackbar = true;
            this.errorText = "Please enter last name";
            break;
          }
          else {
            this.dataModel[0].name = this.dataModel[0].fname + " " + this.dataModel[0].lname
            this.step++;
            break;
          }
        case this.ancestryStep:
          if (
            this.dataModel[0].newGender.legal !== 'Female' ||
            this.dataModel[0].newGender.identity !== 'Female' ||
            this.dataModel[0].newGender.assigned !== 'Female'
          ) {
            this.step += 2;
            break;
          }
          this.step++;
          break;
        default:
          this.step++;
          break;
      }
      this.saveDatatoDB();
      window.scrollTo(0,0);
    },
    genID () {
      var ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

      var ID_LENGTH = 8;

      var generate = function () {
        var rtn = "";
        for (var i = 0; i < ID_LENGTH; i++) {
          rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
        }
        return rtn;
      };
      return generate();
    },
  },
  mounted () {
    this.formType === "patient" ? this.formTypeName = ["your", "you", "Have you", "", "do you have"] : ""
    this.$route.params.id ? this.formID = this.$route.params.id :
      this.formID = this.genID()
  },
  computed: {
    ...mapFields("patientQuestion", [
      "dataModel",
      "formValid",
      "snackbar",
      "errorText",
      "genderList",
      "formID"
    ]),
    ...mapFields([
      "user",
      "snackBarType",
      "snackBarshow",
      "snackBarmessage"
    ]),
    buttonText () {
      switch (this.step) {
        case this.finalStep - 1:
          return "Complete";
        default:
          return "Next";
      }
    },
    progressColor () {
      if (this.step === this.finalStep) {
        return "green";
      }
      return "blue";
    },
    progress () {
      return (this.step / this.finalStep) * 100;
    },
    currentTitle () {
      switch (this.step) {
        case this.nameStep:
          return "Who is this My Genetic Trust for?";
        case this.genderStep:
          return "Sex";
        case this.femaleStep:
          return "Reproductive Health";
        case this.livingStep:
          return this.formTypeName[3] + " currently living?";
        case this.ageStep:
          return "What is your date of birth?"
        case this.ancestryStep:
          return "To the best of your knowledge, what is your ancestry? Or in other words, where did your ancestors live before the United States?"
        case this.infoStep:
          return "Please use this space to provide any additional information about your health or medical history that you would like to share.";
        case this.ConditionStep:
          return "Please let us know of any medical conditions you have/had.";
        case this.surgeriesStep:
          return "Please let us know of any surgeries you have had."
        case this.medicationStep:
          return "Please let us know about any medication you are taking or have an allergy to."
        case this.exposuresStep:
          return "Please let us know about any substances you have been exposed to. (Alcohol, Tobacco, etc.)"
        case this.chilStep:
          return "Please add any children you might have.";
        case this.geneTestStep:
          return this.formTypeName[2] + " completed any genetic testing previously?";
        case this.sibStep:
          return "Please add any siblings you might have.";
        case this.sibStep + 1:
          return "Please add any nieces and/or nephews you might have.";
        case this.sibStep + 4:
          return "Please add any maternal aunts(mother's sisters) you might have.";
        case this.sibStep + 5:
          return "Please add any maternal uncles(mother's brothers) you might have.";
        case this.sibStep + 6:
          return "Please add any maternal cousins you might have.";
        case this.sibStep + 11:
          return "Please add any paternal aunts(father's sisters) you might have.";
        case this.sibStep + 12:
          return "Please add any paternal uncles(father's brothers) you might have.";
        case this.sibStep + 13:
          return "Please add any paternal cousins you might have.";
        case this.finalStep - 1:
          this.complete = true
          return "";

        case this.finalStep:
          this.saveDatatoDB();
          return "Complete";
        default:
          return "";
      }
    }
  }
};
</script>
<style>
v-window-item {
  padding: 20px;
}
</style>
